import styled from '@emotion/styled';
import { mediaQueries } from '../../../../style/global-style';
import { getAssetsPrefix } from '../../../../utils/buildVersion';
import { StyledButtonWrapper } from '../../ugc/ugc.style';

export const StyledUGCReviewSection = styled.section`
    max-width: 1170px;
    margin: 0 auto;
    background: ${(props) => props.theme.shades.white};
    padding: 0 10px 0;

    @media ${mediaQueries.smallDesktopAndUp} {
        padding: 20px 30px 0;
    }

    @media ${mediaQueries.desktopAndUp} {
        padding: 40px 30px 0;
    }
    ${StyledButtonWrapper} {
        padding-top: ${(props) => props.theme.spacingX.tablet};

        button {
            @media ${mediaQueries.phone} {
                border: 0;
            }
            span:first-child {
                @media ${mediaQueries.phone} {
                    padding: 0 ${(props) => props.theme.spacingX.desktop} 0 0;
                }
            }
        }
    }
`;

export const StyledAlReviewsHeader = styled.h3`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    line-height: normal;
    color: ${(props) => props.theme.shades.blackGrey};
    font-weight: 600;
    margin: 0;
    text-align: left;
    padding-bottom: ${(props) => props.theme.spacingX.mobile};
    @media ${mediaQueries.tabletAndUp} {
        padding-bottom: ${(props) => props.theme.spacingX.desktop};
    }
`;
export const StyledUGCArticle = styled.article`
    display: flex;
    margin-bottom: ${(props) => props.theme.spacing.large};
    background: ${(props) => props.theme.shades.white};
    flex-direction: column;
    box-shadow: 0 0 8px 0 ${(props) => props.theme.dropShadows['black-20']};

    @media ${mediaQueries.desktopAndUp} {
        min-height: 315px;
        flex-direction: row;
    }

    > button {
        margin: ${(props) => props.theme.spacingX.mobile} 0
            ${(props) => props.theme.spacingX.desktop};
    }
`;
export const StyledRating = styled.div`
    span {
        /* Custom fontsize, so not using global variable */
        font-size: 25px;
        line-height: ${(props) => props.theme.lineHeight.headlineS};
        @media ${mediaQueries.desktopAndUp} {
            /* Custom fontsize, so not using global variable */
            font-size: 40px;
            line-height: ${(props) => props.theme.lineHeight.headlineXL};
        }
        &:first-child {
            font-weight: 600;
        }
    }
`;

export const StyledAtmosphere = styled.ul`
    margin-bottom: ${(props) => props.theme.spacing.large};
    display: none;
    @media ${mediaQueries.desktopAndUp} {
        margin-bottom: ${(props) => props.theme.spacingX.desktop};
        padding: 0;
        list-style: none;
        display: flex;
        overflow: hidden;
        max-width: 100%;
        flex-wrap: wrap;
        max-height: 25px;
        flex-direction: row;
    }
    li {
        display: inline;
    }
`;

export const StyledCommentParaGraph = styled.p<{
    isCollapsed: boolean;
    scrollContentHeight: number;
}>`
    color: ${(props) => props.theme.shades.blackGrey};
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    line-height: ${(props) => props.theme.lineHeight.headlineXS};
    margin: 0 0 0 ${(props) => props.theme.spacing.large};

    @media ${mediaQueries.desktopAndUp} {
        max-height: ${(props) => (props.isCollapsed ? '75px' : props.scrollContentHeight + 'px')};
        transition: max-height 0.5s ease;
        overflow-y: ${(props) => (props.isCollapsed ? 'hidden' : 'auto')};
    }
`;
export const StyledReviewComment = styled.div`
    display: flex;
    margin-bottom: ${(props) => props.theme.spacing.medium};

    button {
        display: none;
        /* requested by design team */
        outline: 0 none;
        @media ${mediaQueries.desktopAndUp} {
            display: inline-block;
            border: 0;
            background: none;
        }
    }
`;

export const StyledTextOpacity = styled.div`
    position: absolute;
    height: 15px;
    bottom: 0;
    width: calc(100% - 15px);
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 1));
    @media ${mediaQueries.desktopAndUp} {
        display: none;
    }
`;
export const StyledCabinComment = styled.div`
    display: flex;
    @media ${mediaQueries.IE10or11} {
        display: block;
    }
    padding-top: ${(props) => props.theme.spacing.large};
    border-top: 2px solid #eee;
    margin-bottom: 0;
    h4,
    p {
        font-size: ${(props) => props.theme.fontSize.copyTextM};
        line-height: ${(props) => props.theme.lineHeight.headlineXS};
        margin: 0;
        color: ${(props) => props.theme.shades.blackGrey};
        margin-left: ${(props) => props.theme.spacing.large};
    }
`;

const assetPrefix = getAssetsPrefix();
const backgroundImageUrl = `${assetPrefix}/static/user.svg`;

export const StyledReviewHeader = styled.div`
    position: relative;
    color: ${(props) => props.theme.shades.white};

    @media ${mediaQueries.desktopAndUp} {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 32%;
        background-image: url(${backgroundImageUrl});
        background-repeat: no-repeat;
        background-size: 60%;
        background-position: center;
    }
    @media ${mediaQueries.IE10or11} {
        min-height: 315px;
    }
`;
export const StyledReviewBody = styled.div<{ isCollapsed: boolean; scrollContentHeight: number }>`
    padding: ${(props) => props.theme.spacing.large} ${(props) => props.theme.spacing.large} 0;
    max-height: ${(props) => (props.isCollapsed ? '150px' : props.scrollContentHeight + 'px')};
    overflow: ${(props) => (props.isCollapsed ? 'hidden' : 'scroll')};
    transition: max-height 0.5s ease;
    position: relative;

    @media ${mediaQueries.tabletAndUp} {
        max-height: ${(props) => (props.isCollapsed ? '120px' : props.scrollContentHeight + 'px')};
    }

    @media ${mediaQueries.desktopAndUp} {
        padding: 20px 30px;
        width: 68%;
        max-height: none;
        overflow: auto;
    }
    h3 {
        font-size: ${(props) => props.theme.fontSize.headlineXS};
        font-weight: normal;
        color: ${(props) => props.theme.shades.blackGrey};
        margin: 0 0 ${(props) => props.theme.spacing.medium};
        line-height: normal;
        @media ${mediaQueries.desktopAndUp} {
            font-size: ${(props) => props.theme.fontSize.headlineS};
        }
    }
`;

export const StyledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: ${(props) => props.theme.shades.textFadeGradient};
`;
export const StyledAgeRange = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    line-height: normal;
    font-weight: 400;
    @media ${mediaQueries.desktopAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextXL};
        line-height: ${(props) => props.theme.lineHeight.headlineM};
        margin-bottom: 4px;
    }
`;
export const StyledName = styled.h2`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    font-weight: 600;
    line-height: normal;
    margin: 0;

    ${StyledAgeRange} {
        padding-left: ${(props) => props.theme.spacing.small};
    }
    @media ${mediaQueries.desktopAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextXL};
        line-height: ${(props) => props.theme.lineHeight.headlineL};
        margin: ${(props) => props.theme.spacing.large};
        ${(props) => props.theme.spacing.medium};
        ${(props) => props.theme.spacing.small};
    }
`;
export const StyledReviewDesktopHeaderContent = styled.div`
    position: relative;
    text-align: center;
    display: none;
    @media ${mediaQueries.desktopAndUp} {
        display: block;
    }
`;

export const StyledReviewMobileHeaderContent = styled.div`
    display: flex;
    text-align: initial;
    position: relative;
    align-items: center;
    background-image: url(${backgroundImageUrl});
    background-repeat: no-repeat;
    background-position: left -5px bottom;
    background-size: 90px;
    min-height: 90px;
    @media ${mediaQueries.desktopAndUp} {
        display: none;
    }
    > div:nth-of-type(1) {
        padding: ${(props) => props.theme.spacing.large};
        color: ${(props) => props.theme.shades.white};
        @media ${mediaQueries.phone} {
            width: 50%;
        }
    }
    > div:nth-of-type(2) {
        margin-left: auto;
        padding-right: ${(props) => props.theme.spacing.large};
    }
    ${StyledAgeRange} {
        display: inline-block;
    }
`;
export const StyledConstellation = styled(StyledAgeRange)``;

export const StyledShowMoreBtn = styled.button`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    color: ${(props) => props.theme.colors.main4};
    font-weight: 700;
    border: 0;
    background: none;
    outline: 0 none;
    svg {
        position: relative;
        top: 2px;
    }
    @media ${mediaQueries.desktopAndUp} {
        display: none;
    }
`;
